import type { IFallBackTranslations } from '@/Templates/FallBack/Types/translations';

const ptBR: IFallBackTranslations = {
  notFound: {
    title: 'Ops!',
    subtitle: 'Página não encontrada',
    description: 'Parece que você se desconectou do nosso mundo AIoT...',
    button: 'Voltar para a página inicial',
  },
  maintanance: {
    title: 'Já voltamos!',
    subtitle: 'Estamos fazendo alguns ajustes',
    description:
      'Estamos aprimorando sua experiência. Em breve tudo estará ainda melhor! Você pode atualizar a página ou voltar mais tarde.',
  },
  instability: {
    title: 'Aguarde!',
    subtitle: 'Estamos enfrentando alguma instabilidade',
    description:
      'Nosso sistema está passando por instabilidade temporária. Estamos trabalhando para restaurar a funcionalidade completa. Por favor, tente novamente em alguns instantes.',
  },
};

export { ptBR };
